'use strict';

var _merge = require('lodash/merge');
var objectKeys = Object.keys;
var COMMA = ',';
var OPEN = '(';
var CLOSE = ')';
var EMPTY = '';
var OBJECT = 'object';

/**
 * @function ensureObject
 * Ensure that a hydrateObject is actually an object and has
 * iterable key/value pairs.
 * @param  {mixed} hydrateObj Object or other type to validate
 * @return {mixed}            Array of enumerable keys or Boolean `false`
 */
function ensureObject(hydrateObj) {
    if (!hydrateObj || typeof hydrateObj !== OBJECT) {
        throw new TypeError('All levels in hydrateObj must be objects');
    }
    var keys = objectKeys(hydrateObj);
    return !!keys.length && keys;
}

/**
 * @function stingifyIterator
 * Helper funciton for recursive iteration and
 * string building over nested hydrate objects.
 * @param  {string} key Hydrate object (this) key to process
 * @return {string}     Stringifyied value of hydrate object key/value
 */
function stringifyIterator(key) {
    //eslint-disable-next-line no-use-before-define
    var str = stringify(this[key]);
    if (str !== EMPTY) {
        return key + OPEN + str + CLOSE;
    }
    return key;
}

/**
 * @function stringify
 * @description Translate a hydrateObj into a string to use in `hydrate` param of a statsapi call
 * @param hydrateObj Object with key names as hydrates, last hydrate value is an empty object
 * @throws TypeError Hydrates are built from key names in properties, all values must be objects
 * @returns {string} String to be used as `hydrate` param in statsapi call
 */
function stringify(hydrateObj) {
    var str = EMPTY;
    var keys = ensureObject(hydrateObj);
    if (keys) {
        str += keys.map(stringifyIterator, hydrateObj).join(COMMA);
    }
    return str;
}

/**
 * @function merge
 * @description Uses lodash merge to combine multiple hydrateObjs
 * @param dest
 * @param ...sources
 * @note This method mutates `dest` object
 * @returns Merged object
 */
function merge() {
    return _merge.apply(null, arguments);
}

module.exports = {
    stringify: stringify,
    merge: merge
};

